import React, {useState} from 'react';
import './AdminNote.scss';
import preview_img from '../../../../../styles/svg_notes/preview_default.png';
import DataNote from '../DataNote/DataNote';
import { closeInputFormsForNote, uploadNotePart, editNotePart,  
    closeAdminNoteView, activateEditAdminNoteView, changeAdminFoldererView, idNoteAddFilesLoad} from '../../../adminSlice';

//import { validateNoteImageType, validateNoteImageSize } from "../../../adminSlice"; 
//import { validateFileTypeNote, validateFileSizeNote } from '../../../../../helper/validation';
import ImageEditor from './ImageEditor/ImageEditor';
import AdminFolderer from './AdminFolderer/AdminFolderer';
//import PdfViewer from './PdfViewer/PdfViewer';
//import { pdfjs } from "react-pdf";

// DISABLEW WITH PDF VIEWER!!!
/*
pdfjs.GlobalWorkerOptions.workerSrc = new URL(
  "pdfjs-dist/build/pdf.worker.min.mjs",
  import.meta.url,
).toString();
*/

const AdminNote = (props) => {
    const {dispatch} = props;
    const [selectedFiles, setSelectedFiles] = useState([]);
    const [notePartTitle, setNotePartTitle] = useState();
    
    const [noteText, setNoteText] = useState();
    const [noteImgText, setNoteImgText] = useState();
    const [checkImg, setCheckImg] = useState(false);
    const [checkEditImg, setCheckEditImg] = useState(false);
/////////////////////////////////////// -/////////////////////////////////////////////

const activeEditAdminStyle = props.adminEditNoteViewActive; 
const activeAdminStyle = props.adminNoteViewActive;
console.log(selectedFiles);

const handleNoteImgText= (event) => {
    const imgText = event.target.value;
    setNoteImgText(imgText);
}
const handleNoteText = (event) => {
    const text = event.target.value;
    setNoteText(text);
}
const handleNotePartTitle = (event) => {
    const title = event.target.value;
    setNotePartTitle(title);
}
//OPEN-close ADMIN FOLDERER
const handleClickAdminFoldererView = () => {
    dispatch(idNoteAddFilesLoad(props.selectedIdNote));
    dispatch(changeAdminFoldererView());
}

// NOTE PART
//const notePart = 4;
const notePart = props.selectedPartNote;

const handleCheckImageNotePart = () => {
    setCheckEditImg(!checkEditImg);

   }
// CHECK IMG
/*
const selectFiles = (e) => {
    console.log(typeof(e));
    setSelectedFiles(e.target.files[0]);
    //check if file is selected
    if ( e.target.files[0]) {
    //validate type image
    const image = document.getElementById('note-image-file');
    const valideTypeMessage = validateFileTypeNote(image);
    
    dispatch(validateNoteImageType(valideTypeMessage));
    //validate size image
    const valideSizeMessage = validateFileSizeNote(image);
    console.log(valideTypeMessage);
    console.log(valideSizeMessage);
    console.log(e.target.files);
    dispatch(validateNoteImageSize(valideSizeMessage));

    // preview
    let reader = new FileReader();
    reader.onload =() => {
      let output = document.getElementById('pre-notepart-image');
      output.src = reader.result;
      //output.src = '';
    };
    //console.log(reader);
    
      reader.readAsDataURL(e.target.files[0]);


      } else return null;
      
     
  }
 */
// CLEAR INPUT FORMS
const clearInputForms = () => {
    setNotePartTitle('');
    setNoteText('');
    setNoteImgText('');
    setCheckImg(false);
    setSelectedFiles([]);
} 
 // CLEAR IMG TEXT 
const clearImgText = () => {
    
    setNoteImgText('');
    
} 

const clearInputFile = () => {
   document.getElementById('note-image-file').value = '';
}

const clearPreviewPartNote = () => {
   let element =  document.getElementById('pre-notepart-image');
   element.setAttribute('src', preview_img);
   // console.log(document.getElementById('pre-notepart-image').getAttribute('src'));
   
}



//HANDLE UPLOAD -ADD PART NOTE
const handleUpload = e => {
console.log('WTF');
    
    e.preventDefault();
    const valideTypeMessage = props.errorNoteImageValidateType;
    const valideSizeMessage = props.errorNoteImageValidateSize;


if (!valideTypeMessage && !valideSizeMessage) {
   console.log('START UPLOAD AFTER GOOG VALIDATION');
    console.log(props.selectedIdNote, notePartTitle,notePart,noteText,noteImgText, selectedFiles );
    let formData = new FormData();
    formData.append("note_id",props.selectedIdNote);
    formData.append("note_parttitle",notePartTitle);
    formData.append("part",notePart);
    formData.append("text",noteText);
    formData.append("img_text",noteImgText);
    formData.append("file", selectedFiles);
    
    console.log(formData);
   dispatch(uploadNotePart(formData));
   dispatch(closeAdminNoteView());

   //clear input forms
    clearInputForms();
    clearInputFile();
    clearPreviewPartNote();
    setCheckEditImg(false);

} else return null;

  
  }

//HANDLE EDIT PART NOTE
const handleEdit = e => {
    console.log('START EDIT UPLOAD!')
    e.preventDefault();
    const valideTypeMessage = props.errorNoteImageValidateType;
    const valideSizeMessage = props.errorNoteImageValidateSize;


if (!valideTypeMessage && !valideSizeMessage) {
   
    let formData = new FormData();
    formData.append("note_id",props.selectedIdNote);
    formData.append("note_parttitle",notePartTitle);
    formData.append("part",notePart);
    formData.append("text",noteText);
    formData.append("img_text",noteImgText);
    formData.append("file", selectedFiles);
    
    console.log(formData);
   dispatch(editNotePart(formData));
   dispatch(closeAdminNoteView());
   setCheckEditImg(false);
   //clear input forms
    clearInputForms();
    clearInputFile();
    clearPreviewPartNote();
    setCheckEditImg(false);

} else return null;

  
  }


//CLOSE NOTE AND OPEN 
const onCloseNote = () => {
    

    props.handleAdminQuizesView();
    dispatch(closeInputFormsForNote());
    dispatch(closeAdminNoteView());

}

  // CHANGE STATE IF EDIT PART NOTE
  
  const changeOnEditItem = (item) => {
    console.log(item);
    setNotePartTitle(item.notePartTitle);
    setNoteText(item.notePartText);
    setNoteImgText(item.noteImgText);
    dispatch(activateEditAdminNoteView());
  }

  // HAANDLE EXIT ADD NOTE PART
 const handleExitNotePart = () => {
    dispatch(closeAdminNoteView());
    clearInputForms();
    clearInputFile();
    clearPreviewPartNote();
    setCheckEditImg(false);
    
 }
// HANDLE CHECK IMG EDIT

const handleEditImageNotePart = () => {
 setCheckImg(!checkImg);
if (activeAdminStyle) {
    clearInputFile();
    clearPreviewPartNote();
    clearImgText();
}



}



//STYLE UNACTIVE NOTE 
//ACTIVE EDIT 

let style;
//let styleImg;
let styleImgText;
let styleAddButton;
let styleSaveButton;
let styleExitButton;
let styleCheckImg;


//console.log(this.props.adminState.selectedCategory);
if (activeAdminStyle) {
  
        style = '';
        styleAddButton = '';
        styleExitButton = '';
       // styleImg = '';
        styleImgText = '';
        styleSaveButton = 'disabled';
        styleCheckImg = '';
    }
     else {
        style = 'disabled';
        styleExitButton = 'disabled';
        styleAddButton = 'disabled';
        styleSaveButton = 'disabled';
       // styleImg = 'disabled';
        styleImgText = 'disabled';
        styleCheckImg = 'disabled';


}

if (activeEditAdminStyle) {
  
   // styleEdit = 'edit-block'; // block visible
    style = '';
    styleAddButton = 'disabled';
    styleExitButton = '';
    styleSaveButton = '';
   // styleImg = 'disabled';
    styleImgText = 'disabled';
    styleCheckImg = '';

   } 

if (checkImg)  {
   // styleImg = '';
    styleImgText = '';
} else {
   // styleImg = 'disabled';
    styleImgText = 'disabled';
}

// HANDLE FILE FROM IMAGE EDITOR
const handleFileImage = (file) => {
    setSelectedFiles(file);
}



        const view = true;
        if(view) {
            return (
            <div className='AdminNote'>
                <div className="enterContainer">
                       <h4>Заметки</h4>
                       <button  onClick={onCloseNote}  >Назад к тестам</button>
                        {(props.authData.modulesName[6].status || (props.authData.userRole[0].role_id === 1)) ? <div className='container-folder'>
                            <h5> Дополнительные файлы к Заметка_{props.selectedIdNote}</h5>
                            <button onClick={handleClickAdminFoldererView}>Просмотр</button>
                        </div> : null}
                       <label>Название теста</label>
                       <h5>Заметка_{props.selectedIdNote}. {props.selectedIdNoteText}. Часть_{props.selectedPartNote}</h5>
                       <div className="container">

                            
                            
                            <div className="container">
                                <p className='p-text'>Название части</p>
                                <textarea className='text' value={notePartTitle} onChange={handleNotePartTitle} disabled={style} ></textarea>
                                <p className='p-text'>Текст</p>
                                <textarea className='text' value={noteText} onChange={handleNoteText} disabled={style} ></textarea>
                               
                            </div>
                            
                            <div className="container">
                                <fieldset>
                                                <legend>Изменить/Добавить изображение</legend>

                                                <div>
                                                    <input type="checkbox" id="img-part-note" name="img" value={checkImg} onChange={handleEditImageNotePart} disabled={styleCheckImg} checked={checkImg}/>
                                                    <label htmlFor="img"></label>
                                                </div> 
                                </fieldset>
                              
                                    
                                    {/*<input id='note-image-file' type="file" name="note-file" onChange={selectFiles}  disabled={styleImg} />*/}
                                    

                                    {/*<img id='pre-notepart-image' src={preview_img} alt="PartNoteImage" className="prePartNoteImage"/>
                                    
                                    <p className='err-text'>{props.errorNoteImageValidateSize}</p>
                                    <p className='err-text'>{props.errorNoteImageValidateType}</p>
                                    */}
                                    
                                    <ImageEditor
                                    checkImg = {checkImg}
                                    activeEditAdminStyle = {props.adminEditNoteViewActive}
                                    activeAdminStyle = {props.adminNoteViewActive}    
                                    handleFileImage = {handleFileImage}   
                                    handleCheckImageNotePart = {handleCheckImageNotePart}
                                    checkEditImg = {checkEditImg}
                                    errorNoteImageValidateType={props.errorNoteImageValidateType}
                                    errorNoteImageValidateSize={props.errorNoteImageValidateSize}
                                    dispatch={dispatch}
                                    />



                                    <p className='p-text'>Текст к изображению</p>
                                    <textarea  className='img-text' value={noteImgText} onChange={handleNoteImgText} disabled={styleImgText}></textarea>
                                   
                                   <div >
                                    <button className='addButton'  disabled={styleAddButton} onClick={handleUpload}>Добавить</button>
                                   </div>
                                    
                                    <div >

                                        <button className='saveButton'  disabled={styleSaveButton} onClick={handleEdit} >Сохранить</button>
                                      
                                    </div> 

                               
                                    
                            </div>
                            
                            
                            
                                
                                <button className='addButton' onClick={handleExitNotePart} disabled={styleExitButton} >Отмена</button> 
                                                
                        </div>
                    
                        
    
    
                    
                </div>
                <div>
                    <DataNote
                        dispatch={dispatch}
                        selectedIdNote={props.selectedIdNote}
                        selectedIdNoteText = {props.selectedIdNoteText}
                        dataNotes = {props.dataNotes}

                        errorNoteImageValidateType = {props.errorNoteImageValidateType}
                        errorNoteImageValidateSize = {props.errorNoteImageValidateSize}
                        onChangePartNote = {changeOnEditItem}
                        onClearInputForms = {clearInputForms}
                    
                    />
                </div>
                {props.adminFoldererView && <AdminFolderer
                
                       
                    selectedIdNote = {props.selectedIdNote}
                    noteAddFiles = {props.noteAddFiles}
                    selectedIdAddFile = {props.selectedIdAddFile}
                    openDeleteInputFormsForAddFile = {props.openDeleteInputFormsForAddFile}
                    errorAddFileValidateType = {props.errorAddFileValidateType}
                    errorAddFileValidateSize = {props.errorAddFileValidateSize}
                    dispatch={dispatch}
                    />
                }
                {/*props.adminPdfViewer && <PdfViewer
                
                       
                    selectedIdNote = {props.selectedIdNote}
                    pdfName = {props.pdfName}

                    dispatch={dispatch}
                    />
                */}

            </div>
            )
        } else return null;
        

    
}
export default AdminNote;